window.toggleTitulares = function (postId) {
  const toggleInput = document.querySelector(`#checkbox-titular-${postId}`)
  const toggleText = document.querySelector(`#checkbox-titular-${postId}-label`)
  const formWrapper = document.querySelector(`#sacar-a-titulares-${postId}`)
  const form = formWrapper.querySelector(`#edit-titular-${postId}`)
  const toolWrapper = toggleInput.closest('.rnk-ThreadTool_Tool-sacar-titular')
  const tools = toolWrapper.closest('.rnk-ThreadTools')
  const toolInternacional = tools.querySelector('.rnk-ThreadTool_Tool-internacional')

  function showForm () {
    if (form) {
      form.style.display = ''
    } else {
      fetchForm()
    }
  }

  function hideForm () {
    if (form) form.style.display = 'none'
  }

  function hideInternacionalTool () {
    if (toolInternacional) toolInternacional.style.display = 'none'
  }

  function lockToolTrigger () {
    toolWrapper.classList.add('rnk-Locked')
  }

  function unlockToolTrigger () {
    toolWrapper.classList.remove('rnk-Locked')
  }

  function onFormFetched (formHTML) {
    formWrapper.insertAdjacentHTML('beforeend', formHTML)
    toggleText.innerHTML = 'Quitar de titulares'
    unlockToolTrigger()
    scrollToNode(formWrapper)
  }

  function onDeletedFromTitulares () {
    toggleText.innerHTML = 'Sacar a titulares'
    unlockToolTrigger()
  }

  function fetchForm() {
    lockToolTrigger()
    fetch(`/titulares/${postId}/sacar_a_titulares`)
      .then(response => response.text())
      .then(responseText => onFormFetched(responseText))
      .catch(err => console.log(e))
  }

  function deleteFromTitulares() {
    lockToolTrigger()
    // Sin el token CSRF, Rails atiende la petición sin sesión y no quita nada.
    const token = document.querySelector('meta[name="csrf-token"]')?.content ?? ''
    fetch(`/titulares/quitar/${postId}`, { method: 'POST', headers: { 'X-CSRF-Token': token } })
      .then(response => response.text())
      .then(responseText => onDeletedFromTitulares())
      .catch(err => console.log(e))
  }

  if (toggleInput.checked) {
    showForm()
  } else {
    hideForm()
    hideInternacionalTool()
    deleteFromTitulares()
    toggleInput.checked = false
  }
}
